export default function UserIcon({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={!!width ? width : "20"}
      height={!!height ? height : "21"}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99984 8.83317C11.8408 8.83317 13.3332 7.34079 13.3332 5.49984C13.3332 3.65889 11.8408 2.1665 9.99984 2.1665C8.15889 2.1665 6.6665 3.65889 6.6665 5.49984C6.6665 7.34079 8.15889 8.83317 9.99984 8.83317Z"
        fill="currentColor"
      />
      <path
        d="M16.6668 15.0835C16.6668 17.1546 16.6668 18.8335 10.0002 18.8335C3.3335 18.8335 3.3335 17.1546 3.3335 15.0835C3.3335 13.0124 6.31826 11.3335 10.0002 11.3335C13.6821 11.3335 16.6668 13.0124 16.6668 15.0835Z"
        fill="currentColor"
      />
    </svg>
  );
}
